import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MessageService, ConfirmationService } from 'primeng/api';
import { Component, OnInit, Input, EventEmitter, Output, Inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { AlertService } from '@app/_services';
import * as moment from 'moment';
import { PrimeNGConfig } from 'primeng/api';
import { ChartAccount } from '../chart-account';
import { ChartAccountService } from '../chart-account.service';

@Component({
    selector: 'app-chart-account',
    templateUrl: './chart-account.component.html',
    styleUrls: ['./chart-account.component.css'],
    providers: [MessageService, ConfirmationService],
    standalone: false
})
export class ChartAccountComponent implements OnInit {

	constructor(
		private primengConfig: PrimeNGConfig,
		private chartAccountService: ChartAccountService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private formBuilder: UntypedFormBuilder,
		@Inject(MAT_DIALOG_DATA) data: any) {
		this.formTitle = data.title,
			this.chartAccount = data.chartAccount,
			this.statuses = chartAccountService.statuses;
	}

	@Input() chartAccount: ChartAccount;
	@Output() doAdd = new EventEmitter<any>();
	@Output() doUpdate = new EventEmitter<any>();
	@Output() doDelete = new EventEmitter<any>();

	// data
	chartAccountId: number;

	// forms
	form1: UntypedFormGroup;
	formLoading = false;
	formAlert: String;
	formTitle: String;

	statuses: any;

	validationMessages = {
		'chartAccountId': [],
		'actType': [],
		'actCode': [],
		'actName': [],
		'description': [
			{ type: 'required', message: 'Required' }
		],
		// 'status': [],
		// 'chartAccountDate': [],
		// 'isChartAccount': [],
	};

	ngOnInit() {
		this.primengConfig.ripple = true;
		this.formBuild();

		// if we were passed the whole chartAccount object
		if (this.chartAccount) {
			this.chartAccountId = this.chartAccount.chartAccountId;
			this.fixDates();
			this.form1.patchValue(this.chartAccount);
		}
	}

	onFormDelete() {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + this.chartAccountId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete()
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}

	formAdd() {
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			console.log('property-add post: ' + JSON.stringify(this.form1.value));
			this.formLoading = true;
			this.chartAccountService.add(this.form1.value)
				.subscribe(
					(res: any) => {
						console.log('property-add SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.chartAccount = res.data.chartAccount;
						this.doAdd.emit(this.chartAccount);
					},
					(err: any) => {
						console.log('chartAccount-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });

		} catch (error) {
			this.alertService.error(error);
		}
	}

	formUpdate() {
		console.log('chartAccount: ' + JSON.stringify(this.form1.value));
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			this.formLoading = true;

			this.chartAccountService.update(this.form1.value)
				.subscribe(
					(res: any) => {
						console.log('property-update SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.chartAccount = res.data.chartAccount;
						this.doUpdate.emit(this.chartAccount);
					},
					(err: any) => {
						console.log('property-update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	formDelete() {
		try {
			this.chartAccountService.delete(this.chartAccount.chartAccountId)
				.subscribe(
					(res: any) => {
						console.log('chartAccount-delete SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.doDelete.emit(this.chartAccount);
					},
					(err: any) => {
						console.log('chartAccount-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			this.alertService.error(error);
		}
	}

	formBuild() {
		this.form1 = this.formBuilder.group({
			chartAccountId: [this.chartAccountId],
			actType: [],
			actCode: [],
			actName: [],
			description: [],
			
			// status: [],
			// chartAccountDate: [],
			// isChartAccount: [],
		});
	}

	fixDates() {
		// create date objects - why can't primeng do this?
		this.chartAccount.chartAccountDate = moment(this.chartAccount.chartAccountDate).toDate();
	}
}
